function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { typography } from '@arc/frontend/ui-theme';
const styles = {
  container: process.env.NODE_ENV === "production" ? {
    name: "1dgv8bf",
    styles: "display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-start"
  } : {
    name: "1ihk4sb-container",
    styles: "display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-start;label:container;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  label: process.env.NODE_ENV === "production" ? {
    name: "1hl83va",
    styles: "margin-bottom:0.75rem"
  } : {
    name: "dfg6l2-label",
    styles: "margin-bottom:0.75rem;label:label;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
/**
 * Text with a label on it that should line up nicely with single line inputs and their labels.
 */
export function TextWithLabel({
  containerStyle,
  labelType = 'label',
  label,
  labelStyle,
  textType = 'emptySmall',
  text,
  textStyle
}) {
  return <div css={[styles.container, containerStyle, process.env.NODE_ENV === "production" ? "" : ";label:TextWithLabel;"]}>
			<div css={[styles.label, typography[labelType], labelStyle, process.env.NODE_ENV === "production" ? "" : ";label:TextWithLabel;"]}>{label}</div>
			<div css={[typography[textType], textStyle, process.env.NODE_ENV === "production" ? "" : ";label:TextWithLabel;"]}>{text}</div>
		</div>;
}